var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseImg',{attrs:{"title":("About " + _vm.shortcode),"bgName":"bg_about.png"}}),_c('BaseAbout',{attrs:{"isBgBlue":false}}),_c('BaseSupporters')],1)}
var staticRenderFns = []

export { render, staticRenderFns }